import { useNavigate, useParams } from 'react-router-dom';
import { Spin, Result, Button } from 'antd';
import { useSocialPostById } from 'hooks/api/useSocialPost';
import Routes from 'config/routes';
import PostPreview from '../Preview';

const SocialView = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: post, isLoading, isError } = useSocialPostById(id!);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 80 }}>
        <Spin size='large' />
      </div>
    );
  }

  if (isError || !post) {
    return (
      <Result
        status='404'
        title='Пост не знайдено'
        extra={<Button onClick={() => navigate(Routes.SOCIAL_LIST)}>До списку</Button>}
      />
    );
  }

  return (
    <div style={{ maxWidth: 800, margin: '24px auto' }}>
      <PostPreview
        post={post}
        onBack={() => navigate(Routes.SOCIAL_LIST)}
      />
    </div>
  );
};

export default SocialView;
